'use client';

import { getSanityImageUrl, getPageById } from '@/libs/sanity/client'; // nhớ import thêm getPageById
import Image from 'next/image';
import { useEffect, useState } from 'react';
import TimelineSidebar from './TimelineSidebarPartner';

interface listItemsPartnersProps {
  name?: string;
  ctas?: Array<{
    link?: {
      label?: string;
      type: string;
      _type: string;
      internal?: {
        _ref?: string;
        ref?: any;
      };
      external?: string;
    };
  }>;
}

interface LeftTextRightImagePartnerProps {
  name?: string;
  title?: string;
  description?: any;
  image?: any;
  titleListItems?: string;
  listItemsPartners?: listItemsPartnersProps[];
}

export default function LeftTextRightImagePartner({
  name,
  title,
  description,
  image,
  titleListItems,
  listItemsPartners,
}: LeftTextRightImagePartnerProps) {
  // const [selectedIndex, setSelectedIndex] = useState(0);
  const [internalRefs, setInternalRefs] = useState<string[]>([]);

  useEffect(() => {
    const fetchInternalLinks = async () => {
      if (listItemsPartners) return;
      const refs = await Promise.all(
        listItemsPartners.map(async (item) => {
          const cta = item.ctas?.[0];
          if (cta?.link?.internal?._ref) {
            const page = await getPageById(cta.link.internal._ref);
            return page?.metadata?.slug?.current || '#';
          }
          return '#';
        })
      );
      setInternalRefs(refs);
    };

    fetchInternalLinks();
  }, [listItemsPartners]);

  const selectedIndex = title === 'Some of Our Partners' ? 0 : 1;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 mt-11 bg-white ">
      <div className="col-span-1 ml-12">
        {/* Sidebar */}
        <TimelineSidebar selectedIndex={selectedIndex} />
      </div>

      {/* Main Content */}
      <div className="flex flex-1 flex-col lg:flex-row gap-16 col-span-4 mr-5">
        <div className="flex-1">
          <h1 className="text-4xl font-sans mb-6">{title || name}</h1>

          {/* Description */}
          {description && (
            <div className="text-gray-700 mb-8 space-y-5 leading-relaxed">
              {Array.isArray(description) ? (
                description.map((block: any, i: number) => (
                  <p className="font-sans text-sm leading-6" key={i}>
                    {block.children?.[0]?.text}
                  </p>
                ))
              ) : (
                <p className="font-sans text-sm leading-6">{description}</p>
              )}
            </div>
          )}

          {/* Sub Items */}
          {titleListItems && (
            <div className="max-w-xs">
              <p className="text-lg font-sans mb-8  text-left">
                {titleListItems}
              </p>
            </div>
          )}

          <div className="flex flex-col gap-4">
            {listItemsPartners?.map((item, idx) => {
              const cta = item.ctas?.[0];
              const label = cta?.link?.label || item.name || 'Learn More';

              return (
                <div
                  key={idx}
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <div className="w-4 h-4 rounded-full border-2 border-[#BF984D] flex-shrink-0" />
                  <span className="font-sans text-sm">{label}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right Image */}
        {image && (
          <div className="mt-2 flex-shrink-0">
            <Image
              src={getSanityImageUrl(image)}
              alt="Hero Image"
              className=" object-cover shadow"
              width={450}
              height={450}
              loading="lazy"
            />
          </div>
        )}
      </div>
    </div>
  );
}
